// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__1hcE7","summary":"CartItem_summary__zT-S4","price":"CartItem_price__3fB9Q","amount":"CartItem_amount__3-ePz","actions":"CartItem_actions__1nZiy"};